import React from 'react';
import Box from '@mui/material/Box';
import { Container, Value } from './styles';

class ErrorReason extends React.Component {
  render() {
    return (
      <Box sx={{ display: 'flex' }}>
        <Container>
          <Value>{this.props.value}</Value>
        </Container>
      </Box>
    );
  }
}

export default ErrorReason;
